import {QueryStringService} from './Services/QueryStringService';

export class ProductModule {

	constructor(dropdownNavigationModule) {
		this.dropdownNavigationModule = dropdownNavigationModule;
		this.queryStringService = new QueryStringService();
		this.filterParamKey = 'product';
		this.init();
	}

	init() {
		$("[data-productnav-name]").on('click', (e) => {
			this.handleClick($(e.currentTarget));
		});

		this.maybeInvokeWithParam();
	}

	handleClick($el) {
		let productName = $el.data('productnav-name');
		let productTitle = $el.text();
		let $productToShow = $("[data-productnav-item='" + productName + "']");

		this.updateProductView($productToShow);
		this.updateFilterView($el, productTitle);
		this.scrollToProduct();
	}

	updateProductView($el) {
		$("[data-productnav-item]").removeClass('active');
		$el.addClass('active');
	}

	updateFilterView($el, productTitle) {
		$("[data-productnav-name]").removeClass('active');
		$el.addClass('active');

		//In mobile filter
		$("[data-dropnav-trigger]").find('span').text(productTitle);
		this.dropdownNavigationModule.closeNavigation();
	}

	scrollToProduct() {
		let yPosition = parseInt($("[data-product-scrolltarget]").offset().top);
	    $('html,body').animate({ scrollTop: yPosition}, 600);
	}

	maybeInvokeWithParam() {
		let filterParam = this.queryStringService.getQueryStringValue(this.filterParamKey);

		if (filterParam) {
			/**
			 * Two copies of selector exists. one in desktop and the same in mobile filter.
			 * Only use one (whichever because they are the same)
			 */
			let $navElement = $("[data-productnav-name='" + filterParam + "']").first();

			if ($navElement.length) {
				let productName = $navElement.data('productnav-name');
				let productTitle = $navElement.text();
				let $productToShow = $("[data-productnav-item='" + productName + "']");

				this.updateProductView($productToShow);
				this.updateFilterView($navElement, productTitle);
			}

		}
	}
}
